import BpkCard from '@skyscanner-internal/backpack-web/bpk-component-card';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import './DurationAutoselectCard.scss';

type DurationAutoselectCardProps = {
  /** Duration label displayed in the card, e.g. "Weekend" */
  durationString: string;
  /** Date range displayed below duration, e.g. "Feb 14 - 21" */
  dateString?: string;
  /** Formatted price displayed with emphasis, e.g. "£120" */
  priceString?: string;
  /** Click handler when card is selected */
  onClick?: () => void;
  /** Whether this card is currently selected */
  selected?: boolean;
};

export const DurationAutoselectCard = ({
  dateString,
  durationString,
  onClick,
  priceString,
  selected,
}: DurationAutoselectCardProps) => (
  <BpkCard
    className={`duration-autoselect-card ${selected ? 'duration-autoselect-card--selected' : ''}`}
    onClick={onClick}
  >
    <BpkText className="duration-text">{durationString}</BpkText>
    <BpkText className="date-text">{dateString}</BpkText>
    <BpkText textStyle={TEXT_STYLES.heading4} className="price-text">
      {priceString}
    </BpkText>
  </BpkCard>
);
